import { DistributionChannelConnector } from '@/models/distributionChannels';
import { FC } from 'react';

type ConnectorInfoProps = {
  connector: DistributionChannelConnector;
};

export const ConnectorInfo: FC<ConnectorInfoProps> = ({ connector }) => {
  return (
    <div className='flex items-center gap-8 h-fit'>
      <img src={connector.icon} className='size-9 rounded-full' />
      <p className='text-secondary-700 text-sm font-semibold'>{connector.name}</p>
    </div>
  );
};
